import { render, staticRenderFns } from "./MediakitSuperIcon.vue?vue&type=template&id=0a2c991c&"
import script from "./MediakitSuperIcon.vue?vue&type=script&lang=js&"
export * from "./MediakitSuperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports